/*-----------------------------------------------------------------------------
|> TVGuide Channel schedules Component
|------------------------------------------------------------------------------
|
| Render schedules for a specific channel
|
-----------------------------------------------------------------------------*/
<template>
    <div ref="airings" class="vw-channel-airings channel-airings">
        <airing :airing="data[0]" :is-current="true" />

        <airing
            v-for="(airing, index) in data"
            :key="index"
            :airing="airing"
        />
    </div>
</template>

<script>
import Airing from '@components/iptv/ChannelAiring.vue';

const SCROLL_DIRECTION_LEFT = 2;
const SCROLL_DIRECTION_RIGHT = 4;

export default {
    name: 'ChannelSchedules',
    components: { Airing },
    props: {
        data: { type: Array, required: true },
        swipeHandler: { type: Function, required: true },
    },
    data() {
        return {
            touchStartX: null,
            touchStartY: null,
        }
    },
    mounted() {
        this.$refs.airings.addEventListener('touchstart', this.handleTouchStart, false);
        // this.$refs.airings.addEventListener('touchmove', this.handleTouchMove, false);
        this.$refs.airings.addEventListener('touchend', this.handleTouchEnd, false);
    },
    methods: {
        handleTouchStart(evt) {
            this.touchStartX = evt.touches[0].clientX;
            this.touchStartY = evt.touches[0].clientY;
        },
        handleTouchEnd(evt) {
            const deltaX = evt.changedTouches[0].clientX - this.touchStartX;
            const deltaY = evt.changedTouches[0].clientY - this.touchStartY;

            // console.log(deltaX, deltaY)

            if (Math.abs(deltaX) > Math.abs(deltaY)) { // horizontal scroll
                if (deltaX > 0) {
                    // console.log('right swp ', deltaX)
                    this.swipeHandler({
                        raw: evt,
                        direction: SCROLL_DIRECTION_RIGHT,
                        distance: Math.abs(deltaX),
                    });

                } else {
                    // console.log('left swp ', deltaX)
                    this.swipeHandler({
                        raw: evt,
                        direction: SCROLL_DIRECTION_LEFT,
                        distance: Math.abs(deltaX),
                    });
                }
            }
        },
        // handleTouchMove(evt) {
        //     if (!this.touchStartX || !this.touchStartY) return;

        //     const touchEndX = evt.touches[0].clientX;
        //     const touchEndY = evt.touches[0].clientY;
        //     const deltaX = this.touchStartX - touchEndX;
        //     const deltaY = this.touchStartY - touchEndY;

        //     if (Math.abs(deltaX) > Math.abs(deltaY)) { // horizontal scroll
        //         if (deltaX < 0) {
        //             console.log('right swp ')

        //         } else {
        //             console.log('left swp ')
        //         }
        //     }

        //     console.log(this.touchStartX, touchEndX, deltaX)
        // },
    }
}
</script>
